import { useEffect, useState } from "react";

import { Container, Offcanvas } from "react-bootstrap";
import { useSelector } from "react-redux";

import SntCloseIcon from "@icons/SntCloseIcon";

import SidebarBody from "./SidebarBody";
import SidebarLogo from "./SidebarLogo";

import CloudWhiteIcon from "@images/cloud-logo-white.svg";
import CloudBlueIcon from "@images/cloud-icon-blue-01-32x32.png";

function Sidebar() {
  const [showMenu, setShowMenu] = useState(false);
  const { logoPath, menuType, showCanvasMenu } = useSelector(
    (state) => state.all
  );
  const { isMobile } = useSelector((state) => state.all);
  const loginInfo = useSelector((state) => state.user);

  useEffect(() => {
    setShowMenu(showCanvasMenu);
  }, [showCanvasMenu]);

  // only close when click on link of sidebar
  const onOffCanvasClicked = (e) => {
    e.preventDefault();
    if (
      e.target.classList.contains("nav-link") ||
      e.target.classList.contains("sidebar-normal")
    ) {
      showMenu && setShowMenu(false);
    }
  };

  return !isMobile ? (
    <Container>
      <div
        className="sidebar snt-sidebar"
        data-color={menuType === "MAIN" ? "home" : "admin"}
      >
        <SidebarLogo logoPath={logoPath} />
        <SidebarBody />
      </div>
    </Container>
  ) : (
    <Container>
      <Offcanvas
        show={showMenu}
        onHide={() => {
          setShowMenu(false);
        }}
        style={{
          width: "100%",
          backgroundColor: menuType === "MAIN" ? "#4E5471" : "#EFF3F4",
        }}
        collapseonselect={"true"}
      >
        <div>
          <div className="text-center" style={{ marginTop: 5 }}>
            {isMobile && loginInfo.custumInfo === undefined && (
              <img
                src={menuType === "MAIN" ? CloudWhiteIcon : CloudBlueIcon}
                style={{ width: 32, height: 32 }}
                alt={"Logo"}
              />
            )}
          </div>
          <SntCloseIcon
            size={20}
            style={{
              color: menuType === "MAIN" ? "white" : "grey",
              position: "absolute",
              right: 13,
              top: 13,
            }}
            onClick={() => setShowMenu(false)}
          />
        </div>
        <Offcanvas.Body className="p-0" onClick={onOffCanvasClicked}>
          <div
            className="sidebar snt-sidebar"
            data-color={menuType === "MAIN" ? "home" : "admin"}
          >
            <SidebarBody />
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </Container>
  );
}

export default Sidebar;
